import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  async canActivate(): Promise<boolean> {
    if (this.authenticationService.auth.token) {
      try {
        const response = await this.authenticationService.checkAuthentication() as any;
        if (response.success) {
          return true;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
        this.router.navigate(['/login']);
        return false;
      }
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}